import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-three-container content-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "message-container" }
const _hoisted_4 = { class: "description-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('contact.page.message.label')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_TextInput, {
        class: "input",
        modelValue: _ctx.object,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.object) = $event)),
        label: _ctx.$t('contact.page.message.object')
      }, null, 8, ["modelValue", "label"]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("textarea", {
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleDescriptionFocus(false))),
          onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleDescriptionFocus(true))),
          class: "description-input",
          name: "descriptif",
          id: "descriptif",
          cols: "30",
          maxlength: "4000",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event))
        }, null, 544), [
          [_vModelText, _ctx.description]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["label", _ctx.description.trim() || _ctx.descriptionFocus ? 'active-label' : ''])
        }, _toDisplayString(_ctx.$t('contact.page.message.description')), 3)
      ])
    ])
  ]))
}